import { useAxiosPrivate } from "./axios";

const LIST_WORKERS_SCHEDULE_QUERY = "/calendar/schedules";

export const useListWorkersSchedules = () => {
  const listWorkersSchedules = async (userIds, start, end, callback) => {
    try {
      const controller = new AbortController();
      const response = await axiosPrivate.get(LIST_WORKERS_SCHEDULE_QUERY, {
        params: {
          userId: [...userIds],
          start: start,
          end: end,
        },
        paramsSerializer: {
          indexes: null,
        },
        signal: controller.signal,
      });
      callback(response.data);
    } catch (err) {
      callback(err);
    }
  };

  const axiosPrivate = useAxiosPrivate();
  return listWorkersSchedules;
};
